var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBicycleHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29385",
    "data-name": "Group 29385",
    transform: "translate(-221 -262.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(221 262.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_13_",
    "data-name": "svgexport-17 (13)",
    transform: "translate(235 269.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50051",
    "data-name": "Path 50051",
    d: "M178.2,103.427a.361.361,0,0,1-.33-.216l-2.006-4.573a.5.5,0,0,1,.289-.669l.073-.026-2.055-.564-.5.14a.36.36,0,0,1-.2-.694l.594-.167a.36.36,0,0,1,.193,0l3.079.846a.418.418,0,0,1,.03.8l-.754.269,1.91,4.353a.361.361,0,0,1-.33.505Zm-8.892.613a.361.361,0,0,1-.347-.262l-1.033-3.644a.36.36,0,1,1,.694-.2l1.033,3.644a.36.36,0,0,1-.347.459Z",
    transform: "translate(-159.94 -96.644)",
    fill: "#006289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50052",
    "data-name": "Path 50052",
    d: "M341.542,237.491a4.144,4.144,0,1,0,4.144,4.144A4.144,4.144,0,0,0,341.542,237.491Zm0,7.231a3.087,3.087,0,1,1,3.087-3.087A3.09,3.09,0,0,1,341.542,244.722Z",
    transform: "translate(-321.382 -230.805)",
    fill: "#0072a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50053",
    "data-name": "Path 50053",
    d: "M406.857,237.491a4.156,4.156,0,0,0-.889.1,4.138,4.138,0,0,1,2.15,1.231,3.085,3.085,0,0,1,0,5.633,4.137,4.137,0,0,1-2.15,1.231,4.144,4.144,0,1,0,.889-8.191Z",
    transform: "translate(-386.697 -230.805)",
    fill: "#006289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50054",
    "data-name": "Path 50054",
    d: "M4.144,240.754A4.144,4.144,0,1,0,8.288,244.9,4.144,4.144,0,0,0,4.144,240.754Zm0,7.231A3.087,3.087,0,1,1,7.231,244.9,3.09,3.09,0,0,1,4.144,247.985Z",
    transform: "translate(0 -233.913)",
    fill: "#0072a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50055",
    "data-name": "Path 50055",
    d: "M67.691,240.754a4.151,4.151,0,0,0-.977.117,4.137,4.137,0,0,1,1.957,1.1,3.086,3.086,0,0,1,0,5.853,4.137,4.137,0,0,1-1.957,1.1,4.144,4.144,0,1,0,.977-8.171Z",
    transform: "translate(-63.547 -233.913)",
    fill: "#006289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50056",
    "data-name": "Path 50056",
    d: "M375.855,224.514a.5.5,0,0,1-.462-.3l-1.952-4.41a.5.5,0,0,1,.923-.408l1.951,4.41a.5.5,0,0,1-.461.709Z",
    transform: "translate(-355.674 -213.282)",
    fill: "#ffb123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50057",
    "data-name": "Path 50057",
    d: "M382.376,223.806l-1.952-4.41a.5.5,0,0,0-.664-.258l2.358,5.333A.5.5,0,0,0,382.376,223.806Z",
    transform: "translate(-361.734 -213.284)",
    fill: "#ff901d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50058",
    "data-name": "Path 50058",
    d: "M87.148,147.995l-.426-.963a.553.553,0,0,0-.745-.274L78.34,150.43a.553.553,0,0,0-.292.648l.156.554-5.152,3.447a.553.553,0,0,0,.339,1.011l5.967-.346.078.277a.553.553,0,0,0,.949.214l6.674-7.653A.553.553,0,0,0,87.148,147.995Zm-11.795,6.874,3.165-2.118.535,1.9Zm4.871-.131-.848-3.019-.139-.493,6.7-3.225.053.12Z",
    transform: "translate(-69.35 -144.326)",
    fill: "#ff4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50059",
    "data-name": "Path 50059",
    d: "M87.148,147.995l-.426-.963a.553.553,0,0,0-.745-.274L78.34,150.43a.553.553,0,0,0-.292.648l.156.554-5.152,3.447a.553.553,0,0,0,.339,1.011l5.967-.346.078.277a.553.553,0,0,0,.949.214l6.674-7.653A.553.553,0,0,0,87.148,147.995Zm-11.795,6.874,3.165-2.118.535,1.9Zm4.871-.131-.848-3.019-.139-.493,6.7-3.225.053.12Z",
    transform: "translate(-69.35 -144.326)",
    fill: "#ff4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50060",
    "data-name": "Path 50060",
    d: "M87.19,148.11a.552.552,0,0,0-.036-.113l-.213-.482-.213-.482a.552.552,0,0,0-.714-.287l-.03.013-1.287.619.487.992.765-.368.053.12-.6.69.063.128a.553.553,0,0,1-.089.587l-5.506,6.314-.015,0a.553.553,0,0,1-.411-.39l-.078-.277-5.967.346a.553.553,0,0,1-.5-.264.553.553,0,0,0-.027.051v0a.552.552,0,0,0-.038.109v.005q-.005.025-.009.05v.009a.548.548,0,0,0,0,.111s0,.009,0,.014,0,.028.007.042l0,.015c0,.018.009.036.015.054a.554.554,0,0,0,.524.377H73.4l5.967-.346.039.139.039.139h0a.547.547,0,0,0,.022.062l.009.021c.006.013.013.026.02.038l.013.023a.554.554,0,0,0,.034.048l.015.018.016.017.012.013.017.017a.562.562,0,0,0,.044.036l.017.012.043.027.013.007.034.016.023.01.015.006a.554.554,0,0,0,.6-.157l6.674-7.653A.553.553,0,0,0,87.19,148.11Z",
    transform: "translate(-69.357 -144.329)",
    fill: "#f33a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50061",
    "data-name": "Path 50061",
    d: "M148.33,148.219l2.438-.946a.267.267,0,0,0,.161-.316l-.014-.055a.267.267,0,0,0-.3-.2l-2.985.5a.267.267,0,0,0-.214.2l-.127.507a.267.267,0,0,0,.263.331l.688-.011A.267.267,0,0,0,148.33,148.219Z",
    transform: "translate(-140.288 -144.327)",
    fill: "#ff4c4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_437",
    "data-name": "Ellipse 437",
    cx: 1.329,
    cy: 1.329,
    rx: 1.329,
    ry: 1.329,
    transform: "translate(9.354 9.961)",
    fill: "#ffb123"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_438",
    "data-name": "Ellipse 438",
    cx: 1.596,
    cy: 1.596,
    rx: 1.596,
    ry: 1.596,
    transform: "translate(9.086 9.693)",
    fill: "#ffb123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50062",
    "data-name": "Path 50062",
    d: "M203.529,312.946a1.6,1.6,0,0,0,0-2.258l-2.258,2.258A1.6,1.6,0,0,0,203.529,312.946Z",
    transform: "translate(-191.717 -300.528)",
    fill: "#ff901d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50063",
    "data-name": "Path 50063",
    d: "M219.646,329.014a.361.361,0,0,1-.221-.076l-1.831-1.422a.36.36,0,1,1,.442-.569l1.542,1.2.243-.321a.36.36,0,1,1,.575.434l-.463.613A.36.36,0,0,1,219.646,329.014Z",
    transform: "translate(-207.133 -315.943)",
    fill: "#006289"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycleHighlighted);
export default __webpack_public_path__ + "static/media/BicycleHighlighted.1e18fa4c84c61c018ac7dc2cf5f67c55.svg";
export { ForwardRef as ReactComponent };